import axios from 'axios';
import { SERVICES_API_BASE_URL } from './apiConfig';

// Use the dynamically loaded base URL and append the specific API path
const API_URL = `${SERVICES_API_BASE_URL}/api/auth`;

export interface RegisterRequest {
  email: string;
  password: string;

  firstName: string;
  lastName: string;

  companyName: string;
  address: string;
  contactNumber: string;

  role: string;
}

export const authApi = {
  register: async (data: RegisterRequest) => {
    return axios.post(`${API_URL}/register`, data);
  },
  login: async (email: string, password: string) => {
    return axios.post(`${API_URL}/login`, { email, password });
  },
  logout: async () => {
    return axios.post(`${API_URL}/logout`);
  }
};